
import React from 'react';

interface StatItem {
  value: string;
  label: string;
}

interface StatisticsSectionProps {
  sectionTitle?: string;
  sectionSubtitle?: string;
  stats?: StatItem[];
}

const DEFAULT_STATS: StatItem[] = [
  { value: "25+", label: "Avaliações Google" },
  { value: "5.0", label: "Média de Estrelas" },
  { value: "3",   label: "Localizações" },
  { value: "50+", label: "Pacientes Atendidos" },
];

export const StatisticsSection: React.FC<StatisticsSectionProps> = ({
  sectionTitle = "Números que Falam por Si",
  sectionSubtitle = "A confiança dos nossos pacientes em números",
  stats = DEFAULT_STATS,
}) => {
  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold font-primary text-gray-800 mb-4">
            {sectionTitle}
          </h2>
          <p className="text-base sm:text-lg lg:text-xl font-secondary text-gray-600">
            {sectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-8">
          {stats.map(({ value, label }) => (
            <div key={label} className="text-center">
              <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-brand-primary mb-2">{value}</div>
              <p className="text-sm sm:text-base text-gray-600 font-text">{label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
